import React, { FormEvent } from 'react'

import { ReceivingFlowController } from '../flow'
import { ActionButton, RfShell } from '../components/RfShell'
import { RfScanField } from '../components/RfScanField'
import { RfStatusBanner } from '../components/RfStatusBanner'
import { ScanForm, TaskHeader } from '../styles'

interface ProductNarrowingScreenProps {
  controller: ReceivingFlowController
  embedded?: boolean
  onExit: () => void
}

export const ProductNarrowingScreen = ({ controller, embedded = false, onExit }: ProductNarrowingScreenProps) => {
  const { state, dispatch } = controller

  const submitProduct = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    dispatch({ type: 'submit-product-barcode' })
  }

  return (
    <RfShell
      title="Receiving"
      phase="Identify ASN"
      embedded={embedded}
      contextSummary={state.reference ? `Reference: ${state.reference}` : undefined}
      contextDetails={null}
      onBack={() => dispatch({ type: 'back' })}
      moreActions={[{ label: 'Exit receiving', onSelect: onExit, danger: true }]}
      actions={
        <ActionButton type="submit" form="product-narrowing-form">
          Continue
        </ActionButton>
      }
    >
      {state.status ? <RfStatusBanner tone={state.status.tone}>{state.status.message}</RfStatusBanner> : null}
      <TaskHeader>
        <h1>Find ASN by product</h1>
      </TaskHeader>
      <ScanForm id="product-narrowing-form" aria-label="Scan product to narrow results" onSubmit={submitProduct}>
        <RfScanField
          label="Product barcode"
          value={state.productBarcode}
          placeholder="Scan product barcode"
          hint="Use a product from this shipment, or leave blank if unavailable."
          onChange={(barcode) => dispatch({ type: 'set-product-barcode', barcode })}
        />
      </ScanForm>
    </RfShell>
  )
}
